import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export const ReactQueryDevTools = () => {
  // Only show in development
  if (import.meta.env.MODE !== 'development') {
    return null;
  }

  return <ReactQueryDevtools initialIsOpen={false} />;
};
